import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLink } from '../../../../assets/images';
import Icon from '../Icon';

import {
  WrapperResultItem,
  WrapperHeaderSection,
  WrapperIcon,
  WrapperBody,
  ResultTitle
} from './style';

const SectionItem = ({ className, title, urlLink, onClick }) => (
  <WrapperResultItem className={className} to={urlLink} onClick={onClick}>
    <WrapperBody>
      <WrapperHeaderSection>
        <WrapperIcon>
          <Icon svg={ArrowLink} size="m" hover />
        </WrapperIcon>
        <ResultTitle>{title}</ResultTitle>
      </WrapperHeaderSection>
    </WrapperBody>
  </WrapperResultItem>
);

SectionItem.propTypes = {
  className: PropTypes.string,
  urlLink: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func
};

SectionItem.defaultProps = {
  urlLink: '/'
};

export default SectionItem;
